export class GameCalcs {
	public Years: number = 0;
	public CurrentYear: number = 0;	
	public Status: string = "";

	public BankBalanceSheet: balanceSheet[];

	stuff() : void {
		this.CurrentYear += 1;
	}

	private _thing: number;
	public set Thing(value: number) {
		this._thing = value;
	}
	public get Thing() : number {
		return this._thing;
	}

}

export interface GameSetup {
	Name: string;
    NumberOfYearsToPlay: number;
    UseBloombergScreens: number;
    DisplayProgress: number;
    StartingBalance: number;
    Application: application;
    SectorDefinition: sectorDefinition[];
    Year: year[];
}

export interface application {
    Liabilities: number;
    CapitalAdj: number;    
}

export interface sectorDefinition {
    ID: number;    
	Name: string;
	AltName: string;    
	Desc: string;
}

export interface year {
	Actual: string;
	Index: number;
	MinutesToComplete: number;
	TRAType: number;
	TREType: number;
	BankBalanceSheet: balanceSheet;
	TypicalBankBalanceSheet: balanceSheet;
	ShapeOfLoans: shape;
	ShapeOfAdvances: shape;
	ShapeOfDeposits: shape;
	Sector: sector[];
	YieldCurve: curve;
	UserInstructions: string;
	Benchmark: benchmark;
}

export class gameBalanceSheet {
	constructor(index:number) {
		this.Index = index;
		this.Bonds = new balanceSheetDetail();
		this.Loans = new balanceSheetDetail();
		this.Advances = new balanceSheetDetail();
		this.Deposits = new balanceSheetDetail();
		this.Equity = new balanceSheetDetail();
	}
	Index: number;	
	Bonds: balanceSheetDetail;
	Loans: balanceSheetDetail;
	Advances: balanceSheetDetail;
	Deposits: balanceSheetDetail;
	Equity: balanceSheetDetail;
}

export class balanceSheetDetail {
	constructor() {
		this.Balance = 0;
		this.DA = 0;
		this.DM = 0;
		this.UC = 0;
		this.UM = 0;
		this.UA = 0;
		this.Actual = 0;
	}
	Balance: number;
	DA: number;
	DM: number;
	UC: number;
	UM: number;
	UA: number;
	Actual: number;

	getCol(iCol : number): number {
		if (iCol == 0) {
			return this.Balance;
		}
		else if (iCol == 1) {
			return this.DA;
		}
		else if (iCol == 2) {
			return this.DM;
		}
		else if (iCol == 3) {
			return this.UC;
		}
		else if (iCol == 4) {
			return this.UM;
		}
		else if (iCol == 5) {
			return this.UA;
		}
		else if (iCol == 6) {
			return this.Actual;
		}
		return null;
	}
	setCol(iCol : number, value: number) {
		if (iCol == 0) {
			this.Balance = value;
		}
		else if (iCol == 1) {
			this.DA = value;
		}
		else if (iCol == 2) {
			this.DM = value;
		}
		else if (iCol == 3) {
			this.UC = value;
		}
		else if (iCol == 4) {
			this.UM = value;
		}
		else if (iCol == 5) {
			this.UA = value;
		}
		else if (iCol == 6) {
			this.Actual = value;
		}
	}
}

export interface balanceSheet {
	Bonds: number;
	Loans: number;
	Advances: number;
	Deposits: number;
	Equity: number;
}

export interface shape {
	ActualBTR: number;
	Point: point[];
}

export interface curve {
	Point: point[];
}

export interface point {
	Name: string;
	Text: string;
}

export interface sector {
	ID: string;
	TypicalAllocation: string;
	Yield: number;
	Duration: number;
	Shape: shape;
	//used for the game
	Name: string;
	AltName: string;    
	Desc: string;
}

export interface benchmark {
	Percentile: number;
	BTR: number;
	Label: string;
}

export interface sectorObject {
	SectorPts: sectorCurves[];
	SectorInfo: sectorHolder[];	
}

export interface sectorHolder {
	Year: number;
	SectorIDs: string[];
	SectorYields: number[];
	SectorDurations: number[];
	SectorCurveShapes:point[][];
	SectorTypicalBank: number[];

}

export interface sectorCurves {
	SectorCurveDA:number[];
    SectorCurveDM:number[];
    SectorCurveUC:number[];
    SectorCurveUM:number[];
    SectorCurveUA:number[];
    SectorCurveActual:number[];
}

export interface gameSectors {
	Index: number;
	ID: string;
	Name: string;
	Yield: number;
	Duration: number;
	TypicalAllocation: number;
	GameValue: number;
}

export interface yearEndChart {
	Name: string;
	Year0Value: string;
	Year0Change: string;
	Year1Value: string;
	Year1Change: string;
	Year2Value: string;
	Year2Change: string;
}

export interface yearEndPerformance {
	Bond: number;
	TRE: number;
	From: number;
	NewEquity:  number;
	Diff: number;
}

export interface timerSettings {
	Length: number;
	From: number;
	To: number;
	Year: string;
}

export interface gameSummary {
	YearIndex: number;
	YearActual: string;
	MyBank: number;
	TypicalBank: number;
	FiftiethPercent: number;
}


// WEBPACK FOOTER //
// ./src/app/game/game.ts